<div class="technical-work-notification-wrapper" [style.padding]="wrapperPaddings()">
  <div class="technical-work-notification" [style.max-width.px]="maxWidth()">
    <span class="technical-work-notification__icon">⚠</span>

    <p class="technical-work-notification__text">
      {{ 'SHARED.TECHNICAL_WORK_NOTIFICATION' | translate }}
      <a class="technical-work-notification__link" href="mailto:support@intebix.com">
        support&#64;intebix.com
      </a>
    </p>
  </div>
</div>
